import { render, staticRenderFns } from "./blog-form.vue?vue&type=template&id=37fbdc52&scoped=true&"
import script from "./blog-form.vue?vue&type=script&lang=js&"
export * from "./blog-form.vue?vue&type=script&lang=js&"
import style0 from "./blog-form.vue?vue&type=style&index=0&id=37fbdc52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fbdc52",
  null
  
)

export default component.exports